<div class="material-toggle" (click)="doToggle()">
    <input type="checkbox" id="toggle-button-{{buttonId}}" name="toggle" [checked]='initialState' class="switch" (change)="toggled.emit($event.target)" (click)="$event.stopPropagation()" [disabled]="isDisabled"/>
    <label for="toggle-button-{{buttonId}}" class="" (click)="$event.stopPropagation()"></label>
</div>